import {LanguageDetectorModule} from 'i18next';

import {detectLanguage} from './lib/detectLanguage';
import {getBrowserLanguagePreferences} from './lib/getBrowserLanguagePreferences';

class BrowserLanguageDetector implements LanguageDetectorModule {
  type = 'languageDetector' as const;

  detect() {
    if (typeof window === 'undefined') {
      return undefined;
    }

    return detectLanguage(
      window.location.href,
      getBrowserLanguagePreferences()
    );
  }
}

export default BrowserLanguageDetector;
